<chart-details-layout [chartDetails]="chartDetails"
                      [isLoading]="isLoading"
                      [showFormButtons]="showFormButtons"
                      (save)="onSaveSettings()"
                      (cancel)="onRevertSettings()">
    <manuals-opened-current-chart chart
                                  [showTitle]="false"></manuals-opened-current-chart>
    <base-details detailsComponent
                  *ngIf="!isLoading"
                  [chartDetails]="chartDetails"
                  [generalSettings]="config?.generalSettings"
                  (generalSettingsChange)="onGeneralSettingsChange($event)">
        <div #filterContent>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group input-group has-feedback" style="position: relative;">
                        <label class="control-group input-group-addon"
                               for="selectExpirationPeriod">
                            Expiration Time Period
                            <button class="info-btn"
                                    type="button"
                                    [attr.title]="info('expirationTimePeriod')"
                                    (click)="onInfoClick($event, 'expirationTimePeriod')">
                                i
                            </button>
                        </label>
                        <select id="selectExpirationPeriod"
                                name="selectExpirationPeriod"
                                [(ngModel)]="sessionExpirationPeriod"
                                class="form-control"
                                (click)="hideTooltip()">
                            <option value="" [selected]="sessionExpirationPeriod === ''">
                                -- Select Expiration Time Period --
                            </option>
                            <option *ngFor="let expirationPeriod of expirationTimePeriods"
                                    [value]="expirationPeriod.value">
                                {{ expirationPeriod.display }}
                                <!--does this need to be a new variable-->
                            </option>
                        </select>

                        <div class="click-tooltip"
                             *ngIf="isTooltipVisible('expirationTimePeriod')"
                             (click)="hideTooltip()">
                            {{ info('expirationTimePeriod') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </base-details>
</chart-details-layout>